import { render, staticRenderFns } from "./BCIEvaluation.vue?vue&type=template&id=11526cfe&scoped=true&class=true&"
import script from "./BCIEvaluation.vue?vue&type=script&lang=ts&"
export * from "./BCIEvaluation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11526cfe",
  null
  
)

export default component.exports